import type { Control, FieldValues, Path } from 'react-hook-form';
import { OptionSelect, type SelectOption } from '@/components/common/OptionSelect';
import { LabelText } from '@/components/common/LabelText';
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { cn } from '@/lib/utils';
import { FIELD_CONTROL_CLASS } from '@/styles/fieldControl';
import { FIELD_LABEL_CLASS, FULL_ROW_FIELD_CLASS } from './formDialog.constants';

interface FormSelectFieldProps<TValues extends FieldValues> {
  control: Control<TValues>;
  name: Path<TValues>;
  label: string;
  options: readonly SelectOption[] | undefined;
  isLoading: boolean;
  placeholder: string;
  isRequired?: boolean | undefined;
  isFullRow?: boolean | undefined;
}

export function FormSelectField<TValues extends FieldValues>({
  control,
  name,
  label,
  options,
  isLoading,
  placeholder,
  isRequired = false,
  isFullRow = false,
}: FormSelectFieldProps<TValues>) {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={cn(isFullRow && FULL_ROW_FIELD_CLASS)}>
          <FormLabel className={FIELD_LABEL_CLASS}>
            <LabelText isRequired={isRequired}>{label}</LabelText>
          </FormLabel>
          <FormControl>
            <OptionSelect
              options={options}
              isLoading={isLoading}
              value={field.value}
              onChange={field.onChange}
              placeholder={placeholder}
              className={FIELD_CONTROL_CLASS}
              clearable
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
